import { type FC, useCallback, useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Button } from '@/components/buttons';
import { useNavigation } from '@/hooks/navigation';
import { usePopupAfterRegSlide } from '@/hooks/popup';
import { useInactiveUser } from '@/hooks/user';
import { useGetCommonStore } from '@/store';
import { ScCookie, ScLink } from './styles';

export type ICookieModalProps = {
  onClose: () => void;
};

export const CookiesModal: FC<ICookieModalProps> = ({ onClose }) => {
  const { t } = useTranslation('common');
  const { navigate } = useNavigation();

  const { isUserInactive } = useInactiveUser();
  const { hidePopup } = usePopupAfterRegSlide();
  const useCommonStore = useGetCommonStore();

  const isMobileDevice = useCommonStore.use.isMobileDevice();

  const handleCookiePolicyRedirect = useCallback(() => {
    navigate('/cookie-policy');
  }, [navigate]);

  const buttonProps = useMemo(
    () =>
      isMobileDevice
        ? { wide: true }
        : {
            autoPaddingHorizontal: true,
            paddingX: 12,
          },
    [isMobileDevice]
  );

  const cookieText = useMemo(
    () => (
      <Trans i18nKey="common:modals.cookie">
        We use cookies to improve your experience. By using our website you are
        accepting our
        <ScLink onClick={handleCookiePolicyRedirect}>Cookie Policy</ScLink>
      </Trans>
    ),
    [handleCookiePolicyRedirect]
  );

  return (
    <ScCookie data-testid="cookie-banner" hide={hidePopup && !isUserInactive}>
      <div>{cookieText}</div>
      <Button
        {...buttonProps}
        onClick={onClose}
        primary
        testId="cookie-continue-button"
        xSmall
      >
        {t('button.continue')}
      </Button>
    </ScCookie>
  );
};
